<template>
    <div :class="containerClass">
        <div class="msg-mode" v-if="type == 'msg'">
            <div class="msg-text text-center">
                <slot>
                    <p v-if="!dangerouslyUseHTMLString">{{message}}</p>
                    <p v-else v-html="message"></p>
                </slot>
            </div>
        </div>
        <div class="msg-mode" v-if="type == 'loading'">
            <div class="loading-text text-center">
                <div class="js-msg-loading-img">
                    <slot>
                        <img src="./tail-spin.svg" alt="loading">
                        <p v-if="!dangerouslyUseHTMLString">{{message}}</p>
                        <p v-else v-html="message"></p>
                    </slot>
                </div>
            </div>
        </div>
        <div class="box js-tips-box" v-if="type == 'optbox'">
            <div class="g-box">
                <div class="g-box-title">
                    <slot>
                        <p v-if="!dangerouslyUseHTMLString">{{message}}</p>
                        <p v-else v-html="message"></p>
                    </slot>
                </div>
                <div class="g-box-foot">
                    <a v-for="(item, index) in button" :key="index" href="javascript:;" v-text="item.text" @click="clickOptBoxBtn(item.handler)"></a>
                </div>
            </div>
        </div>
        <div class="page-nofond" v-if="type == 'errorpage'">
            <div class="nofond-img">
                <img src="../../../global/img/error/error.png" alt="error">
            </div>
            <div class="nofond-min">
                <h1 class="nofond-title">{{retmsg}}</h1>
                <h2 class="nofond-title-tips">{{retcode}}</h2>
                <ul class="nofond-tips">
                    <li>此网页可能暂时出现故障</li>
                    <li>没有网络信号或数据连接</li>
                </ul>
            </div>
            <div class="empty-btn">
                <a class="" data-app-no-open="1" href="javascript:window.location.reload();">刷新</a>
            </div>
        </div>
        <div class="mask vm js-layer-box" v-if="type == 'layer'">
            <div class="anti-cheat">
                temp_html
            </div>
        </div>
        <div class="mask" v-if="type == 'select'">
            <div class="boxbg"></div>
            <div class="boxb">
                <ul class="boxb-ul">
                    <a v-for="(item, index) in selectBox.items" :key="index" :href="item.href" v-text="item.text"></a>
                </ul>
                <a href="javascript:;" class="boxb-btn" v-text="selectBox.btnText" @click="clickSelectBoxBtn(selectBox.btnCallBack)"></a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Tips',
    data(){
        return {
            type: 'msg',  //opt
            dangerouslyUseHTMLString: false,
            containerClass: {
                'error-page': false
            },
            button: [
                {
                    text: '确定',
                    handler: function () {
                        // 确定按钮回调
                        this.close();
                    }
                }
            ],
            selectBox: {
                items: [],
                btnText: '取消',  //底部选项文案
                btnCallBack: function(){  //如果不传则默认为null，点击底部按钮时隐藏弹层
                    this.close();  //隐藏选择层
                }
            },
            speed: 1500,
            retcode: '',
            retmsg: '',
            message: ''
        }
    },
    mounted(){
        if(this.type == 'msg'){
            setTimeout(() => {
                console.log('destroy1');
                this.close();
            }, this.speed)
        }
    },
    methods: {
        clickOptBoxBtn(handler){
            handler.call(this);
        },
        clickSelectBoxBtn(){
            this.selectBox.btnCallBack.call(this);
        },
        close(){
            this.$destroy(true);
            this.$el.parentNode.removeChild(this.$el);
        }
    }
}
</script>
<style lang="less" scoped>
    @import './main.less';
</style>